(function(){
  function ready(fn){if(document.readyState!=='loading'){fn();}else{document.addEventListener('DOMContentLoaded',fn);}}
  ready(function(){
    var scope=document.querySelectorAll('.t3d-scope');
    // Reveal on scroll
    var nodes=[].slice.call(document.querySelectorAll('.t3d-scope [data-reveal]'));
    var vh=window.innerHeight||800;
    function reveal(el){el.classList.add('shown');}
    nodes.forEach(function(el){if(el.getBoundingClientRect().top<vh*1.05){reveal(el);}});
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){reveal(en.target);io.unobserve(en.target);}});},{threshold:0.08,rootMargin:'0px 0px -8% 0px'});
      nodes.forEach(function(el){if(!el.classList.contains('shown')){io.observe(el);}});
    } else { nodes.forEach(reveal); }
    setTimeout(function(){nodes.forEach(reveal);},2500);

    // Animated counters
    function runCounter(el){
      var target=parseFloat(el.getAttribute('data-target'))||0;
      var suffix=el.getAttribute('data-suffix')||'';
      var dur=1500,s=performance.now();
      function step(n){var t=Math.min(1,(n-s)/dur);var e=1-Math.pow(1-t,3);var val=Math.round(target*e);el.textContent=val.toLocaleString('fr-FR')+suffix;if(t<1){requestAnimationFrame(step);}}
      requestAnimationFrame(step);
    }
    var stats=[].slice.call(document.querySelectorAll('.t3d-stat'));
    if(stats.length){
      if('IntersectionObserver' in window){
        var sio=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){runCounter(en.target);sio.unobserve(en.target);}});},{threshold:0.4});
        stats.forEach(function(el){sio.observe(el);});
      } else { stats.forEach(runCounter); }
    }

    // Before / after slider
    [].slice.call(document.querySelectorAll('[data-t3d-ba]')).forEach(function(ba){
      var fill=ba.querySelector('[data-t3d-ba-fill]');
      var handle=ba.querySelector('[data-t3d-ba-handle]');
      var dragging=false;
      function pos(e){var r=ba.getBoundingClientRect();var cx=(e.touches&&e.touches[0])?e.touches[0].clientX:e.clientX;var p=((cx-r.left)/r.width)*100;return Math.max(2,Math.min(98,p));}
      function set(p){if(fill){fill.style.width=p+'%';}if(handle){handle.style.left=p+'%';}}
      function down(e){dragging=true;set(pos(e));}
      function move(e){if(!dragging){return;}set(pos(e));}
      function up(){dragging=false;}
      ba.addEventListener('mousedown',down);window.addEventListener('mousemove',move);window.addEventListener('mouseup',up);
      ba.addEventListener('touchstart',down,{passive:true});ba.addEventListener('touchmove',move,{passive:true});ba.addEventListener('touchend',up);
    });

    // Carousel arrows
    [].slice.call(document.querySelectorAll('[data-t3d-carousel]')).forEach(function(c){
      var track=c.querySelector('[data-t3d-track]');
      var prev=c.querySelector('[data-t3d-prev]');
      var next=c.querySelector('[data-t3d-next]');
      if(prev&&track){prev.addEventListener('click',function(){track.scrollBy({left:-360,behavior:'smooth'});});}
      if(next&&track){next.addEventListener('click',function(){track.scrollBy({left:360,behavior:'smooth'});});}
    });

    // FAQ accordion
    [].slice.call(document.querySelectorAll('[data-t3d-faq-toggle]')).forEach(function(btn){
      btn.addEventListener('click',function(){
        var item=btn.closest('[data-t3d-faq-item]');
        if(!item){return;}
        var open=item.classList.toggle('open');
        var ans=item.querySelector('[data-t3d-faq-ans]');
        var ic=item.querySelector('[data-t3d-faq-ic]');
        if(ans){ans.style.display=open?'block':'none';}
        if(ic){ic.style.transform=open?'rotate(45deg)':'rotate(0deg)';}
      });
    });

    // Sticky mobile CTA visibility
    var sticky=document.querySelector('[data-t3d-sticky]');
    var hero=document.querySelector('[data-t3d-hero]');
    if(sticky&&hero&&'IntersectionObserver' in window){
      new IntersectionObserver(function(es){sticky.classList.toggle('is-visible',!es[0].isIntersecting);}).observe(hero);
    }

    // AJAX add to cart
    [].slice.call(document.querySelectorAll('[data-t3d-add]')).forEach(function(btn){
      btn.addEventListener('click',function(e){
        e.preventDefault();
        var id=btn.getAttribute('data-variant-id');
        if(!id){window.location.href=btn.getAttribute('data-url')||'/cart';return;}
        var orig=btn.textContent;
        btn.textContent='Ajout…';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})})
        .then(function(r){if(!r.ok){throw new Error('add');}return r.json();})
        .then(function(){btn.textContent='Ajouté ✓';return fetch('/cart.js');})
        .then(function(r){return r.json();})
        .then(function(c){[].slice.call(document.querySelectorAll('[data-t3d-cart-count]')).forEach(function(el){el.textContent=c.item_count;});})
        .catch(function(){window.location.href='/cart';})
        .then(function(){setTimeout(function(){btn.textContent=orig;},1600);});
      });
    });
  });
})();
